import { render, staticRenderFns } from "./RecurringsDetailTable.vue?vue&type=template&id=828fc044"
import script from "./RecurringsDetailTable.vue?vue&type=script&lang=js"
export * from "./RecurringsDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('828fc044')) {
      api.createRecord('828fc044', component.options)
    } else {
      api.reload('828fc044', component.options)
    }
    module.hot.accept("./RecurringsDetailTable.vue?vue&type=template&id=828fc044", function () {
      api.rerender('828fc044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Recurrings/RecurringsDetailTable.vue"
export default component.exports